import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideHttpClient,  withFetch } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations'; 
import { provideClientHydration } from '@angular/platform-browser'; 
import { HTTP_INTERCEPTORS,   withInterceptorsFromDi } from '@angular/common/http';
import { HttpApiInterceptor } from '../app/auth/http-api.interceptor';
import { MainComponent } from './main/main.component';
import { ManualComponent } from './manual/manual.component';
import { BlogComponent } from './blog/blog.component';
import { BlogDetailComponent } from './blog/blog-detail.component';
import { BlogResolver } from './blog/blog.resolver';
import { CookiesComponent } from './cookies/cookies.component';
import { TermsComponent } from './terms/terms.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ContactRedirectComponent } from './contact-redirect/contact-redirect.component';
import { TariffsRedirectComponent } from './tariffs-redirect/tariffs-redirect.component';
import { VideoInstructionComponent } from './video-instruction/video-instruction.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18nweb/', '.json?a=' + Date.now());
}
const routes = [
  { path: 'contact', component: ContactRedirectComponent },
  { path: 'tariffs', component: TariffsRedirectComponent },
  { path: 'video-instruction', component: VideoInstructionComponent },
  { path: 'instructions', component: ManualComponent },
  { path: 'blog', component: BlogComponent },
  { 
    path: 'blog/:slug', 
    component: BlogDetailComponent,
    resolve: { article: BlogResolver }
  },
  { path: 'informace-o-cookies', component: CookiesComponent },
  { path: 'obchodni-podminky', component: TermsComponent },
  { path: 'ochrana-osobnich-udaju', component: PrivacyComponent },
  { path: '', component: MainComponent },
  { 
    path: ':slug', 
    component: BlogDetailComponent,
    resolve: { article: BlogResolver }
  }, // Podpora pro články bez /blog/ prefixu - na konci! Musí být po všech specifických routách!
  { path: '**', redirectTo: '' } 
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'top',
      })
    ),
    provideClientHydration(),
    provideAnimations(),
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi()
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpApiInterceptor,
      multi: true
    }, 
    provideTranslateService({
      defaultLanguage: 'cs',
      useDefaultLang: true,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ]
};